<template>
  <div class="trunce">
    <div class="main">
      <div class="main-header">
        <h1 class="main-title">Транзакції за {{ DateToday}}</h1>
        <div class="header-right">
          <div class="inner-addon right-addon">
            <svg class="glyphicon" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="13.5" cy="8.5" r="8" fill="white" stroke="#C4C4C4"/>
              <line x1="8.06066" y1="14.0607" x2="1.06066" y2="21.0607" stroke="#C4C4C4" stroke-width="3"/>
            </svg>
            <input type="text" class="search" placeholder="Пошук по картці/тримачу" v-model="search">
          </div>

          <div class="select" >
            <select v-model="limit">
              <option value=10>10</option>
              <option value=20>20</option>
              <option value=40>40</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </div>
      </div>
      <main-transuction :transactions="transactions" :avgPrice="total.avgPrice" :totalSum="total.totalSum" :totalAmount="total.totalAmount"></main-transuction>
      <div v-if="total.totalCount/limit > 1" class="container">
        <paginate
            :page-count="Math.ceil(total.totalCount/limit)"
            :click-handler="changePage"
            :page-range="4"
            :margin-pages="4"
            :initial-page="page"
            :prev-text="'Попередня'"
            :next-text="'Наступна'"
            :container-class="'pagination'">
        </paginate>
        <div class="pagination-info">
          Показується з {{page * limit - limit + 1}} по {{pageTotal.countOnPage === Number(limit) ? page * limit :  total.totalCount }} із {{ total.totalCount }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MainTransuction from "../components/MainTransuction";
import Paginate from 'vuejs-paginate'
import moment from "moment";
export default {
  name: 'Trance',
  components: {
    MainTransuction,
    Paginate
  },
  filters: {},
  created() {
   this.getData()

  },
  watch: {
    search: function (){
      this.getData()
    },
    limit: function (){
      this.getData()
    },
    page: function (){
      this.getData()
    }
  },
  computed: {
    DateToday: function (){
      return moment().format('DD.MM.YYYY')
    },
  },
  data() {
    return {
      limit: 10,
      page: 1,
      search: null,
      errored: false,
      load: false,
      total: {},
      pageTotal: {},
      transactions: [],
      transaction: [{cardNo:"7825990000386045", transDate: "03.03.2021 3:09:01",  transSum:"2 999,00", station: "ОККО, Одеська, Одеса, Балківська, 115" },
        {cardNo:"7825990000386045", transDate: "03.03.2021 3:09:01",  transSum:"2 999,00", station: "ОККО, Одеська, Одеса, Балківська, 115" },
        {cardNo:"7825990000386045", transDate: "03.03.2021 3:09:01",  transSum:"2 999,00", station: "ОККО, Одеська, Одеса, Балківська, 115" }
      ],
    }
  },
  methods: {
    changePage: function (pageNum){
      this.page = pageNum
    },
    getData: function () {
      this.axios.get('/userservice/v1/User/transactions-simple', {params: {topTransactions: this.limit, page: this.page, search: this.search}})
          .then(response => (
              this.transactions = response.data.data,
              this.total =  response.data.total,
              this.pageTotal =  response.data.pageTotal
              )
          ).catch(error => {
        console.log('error_get_data');
        console.log(error);
        this.errored = true;
      })
          .finally(() => (
              this.load = true)
          )
    },
  }
}
</script>
<style>
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .glyphicon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}
.right-addon .glyphicon { right: 25px;}
.right-addon input { padding-right: 40px; }

.header-right {
  display: flex;
}
.header-right input {
  width: 270px;
  height: 39px;
  margin-right: 25px;
  background: var(--usual-white);
  border: 1px solid var(--strong-grey);
  box-sizing: border-box;
  border-radius: 3px;
  text-align: start;
  text-transform: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  padding-left: 11px;
  /* identical to box height, or 133% */

  font-feature-settings: 'cpsp' on;

  color: var(--strong-grey);
}
.container {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.pagination-info {
  font-size: 17px;
}
.trunce {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
}
.maine{
  width: 70%;
}
.pagination {
  display: flex;
  list-style: none;
  margin-top: 28px;
  margin-block-end: 0;
  padding-inline-start: 0;
}

.pagination li {
  flex: 1;
  margin: 0px 5px;
  background: #f5f5f5;
  border-radius: 3px;
  //box-shadow: -3px -3px 7px #ffffff73, 3px 3px 5px rgba(94, 104, 121, 0.288);
  //max-width: 55px;
}
.pagination li a {
  justify-items: center;
  font-size: 18px;
  text-decoration: none;
  text-align: center;
  color: #4d3252;
  height: 45px;
  width: 55px;
  display: block;
  line-height: 45px;
}
.pagination li.next_page,
.pagination li.next_page a {
  width: 135px!important;

}
.pagination li.last_page a {
  width: 100px!important;
}
li.active {
  background-color: var(--soft-purple);
  //box-shadow: inset -3px -3px 7px #ffffff73,
  //inset 3px 3px 5px rgba(94, 104, 121, 0.288);
}
li {
  cursor: pointer;
}
.pagination li.active a {
  font-size: 17px;
  color: var(--usual-white);
}
.pagination li:first-child {
  margin: 0 45px 0 0;
  background: none;
  //width: 300px;
}
.pagination li:last-child {
  margin: 0 0 0 15px;
  background: none;
}
li.disabled a{
  color: #BDBDBD;
}
select {
  /* Reset Select */
  appearance: none;
  outline: 0;
  border: 0;
  box-shadow: none;
  /* Personalize */
  flex: 1;
  padding: 0 1em;
  //color: #fff;
  background-color: var(--soft-grey);
  background-image: none;
  cursor: pointer;
}
/* Remove IE arrow */
select::-ms-expand {
  display: none;
}
/* Custom Select wrapper */
.select {
  position: relative;
  display: flex;
  width: 8em;
  height: 3em;
  border-radius: .25em;
  overflow: hidden;
}
/* Arrow */
.select::after {
  content: '\25BC';
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.85em;
  background-color: #e1e1e1;
  //transition: .25s all ease;
  pointer-events: none;
}
/* Transition */
.select:hover::after {
  color: var(--soft-purple);
}

.main-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>